import { ColumnDefinition } from "./columns/ColumnDefinitions";
import { BaseTableDefinition, TableDefinition } from "./table";

export class TableDefinitionUtils {
    public static getDataColumns(definition: BaseTableDefinition) {
        let dataColumns: ColumnDefinition[] = [];
        definition.columns.forEach((val) => {
            if (val.type === "ColumnGroup") {
                val.columns.forEach((val2) => {
                    dataColumns.push(val2);
                });
            } else {
                dataColumns.push(val);
            }
        });
        return dataColumns;
    }

    public static getColumnIndexForProperty(column, definition: TableDefinition) {
        let i = 0;
        for (let c of definition.columns) {
            if (c.property === column) {
                return i;
            }
            i++;
        }
    }

    public static rowDataToObject(definition: BaseTableDefinition, rowData: object | any[]) {
        let data = {};
        let dataColumns: ColumnDefinition[] = [];
        dataColumns = TableDefinitionUtils.getDataColumns(definition);
        (rowData as any[])?.forEach((cellData, index) => {
            const field = TableDefinitionUtils.getField(dataColumns, index, definition.extraFields);
            if (field != null) {
                data[field] = cellData;
            }
        });
        return data;
    }

    private static getField(dataColumns: ColumnDefinition[], index: number, extraFields: any[] = []): string {
        if (index < dataColumns.length) {
            return dataColumns[index].property;
        } else {
            return extraFields[index - dataColumns.length];
        }
    }

    public static objectToRowData(definition: BaseTableDefinition, data: any): any[] {
        let dataColumns: ColumnDefinition[] = [];
        dataColumns = TableDefinitionUtils.getDataColumns(definition);
        let row = [];
        for (let index = 0; index < dataColumns.length; index++) {
            const column = dataColumns[index];
            if (column.property != null && data[column.property] !== undefined) {
                row[index] = data[column.property];
            }
        }
        for (let index = 0; index < (definition.extraFields ?? []).length; index++) {
            const property = definition.extraFields[index];
            if (property != null && data[property] !== undefined) {
                row[index + dataColumns.length] = data[property];
            }
        }
        return row;
    }
}
